import { render, staticRenderFns } from "./ProductLinks.vue?vue&type=template&id=30c03664&scoped=true"
import script from "./ProductLinks.vue?vue&type=script&lang=js"
export * from "./ProductLinks.vue?vue&type=script&lang=js"
import style0 from "./ProductLinks.vue?vue&type=style&index=0&id=30c03664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c03664",
  null
  
)

export default component.exports